import { datadogLogs } from "@datadog/browser-logs";
import { datadogRum } from "@datadog/browser-rum";

export const logToDd = (
  message: string,
  event: string,
  data: {},
  uavId: string
) => {
  try {
    datadogLogs.logger.log(message, {
      fullMessage: message,
      event,
      uav: uavId,
      role: "p1o",
      uav_id: uavId?.replace("MNA-", ""),
      timestamp: `${Date.now()}`,
      ...data,
    });
  } catch (err) {
    console.log(err);
  }
};

export const addAction = (action: string, data: any) => {
  datadogRum.addAction(action, {
    data,
  });
};
